<template>
	<PageDisplay :loading="loading" :loadNum="loadNum">
		<rearviewContent></rearviewContent>
	</PageDisplay>
</template>

<script>
import PageDisplay from './Loading/loading'
import rearviewContent from './content'
import { sleep } from '@/tools/tool.js'

export default {
	data() {
		return {
			loading: true,
			loadNum: 0.85
		}
	},
	components: {
		PageDisplay,
		rearviewContent
	},
	mounted() {
		this.pageControl()
	},
	methods: {
		pageControl() {
			document.onreadystatechange = () => {
				if (document.readyState === 'complete' || document.readyState === 4) {
					setTimeout(async () => {
						this.loadNum = 1
						await sleep(400)
						this.loading = false
					}, 1500)
				}
			}
		}
	}
}
</script>
